export default function checkGame(released: string | null) {
    // If game is Destiny 1
    if(released === "Destiny" || released === "The Dark Below" || released === "House of Wolves" || released === "The Taken King" || released === "Rise of Iron"
        || released === "Age of Triumph"
    ) {
        return true;
    }
    // If released is null or empty
    else if(released === null || released === "") {
        return false;
    }
    // If game is Destiny 2
    else {
        return false;
    }
}